<template>
<header class="sticky-top">
  <nav class="navbar navbar-expand-md navbar-dark bg-primary" aria-label="Offcanvas navbar large">
    <div class="container-fluid">
      <a class="navbar-brand m-0" href="#"><img src="@/assets/logo-sm.svg" alt=""></a>
      <span class="d-none d-md-inline-block px-3 text-light text-opacity-25">|</span>
      <button class="navbar-toggler shadow-none border-0 p-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="offcanvas offcanvas-end text-white bg-primary w-75" tabindex="-1" id="offcanvasNavbar2">
        <div class="offcanvas-header">
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close" ref="sideBar"></button>
        </div>
        <div class="offcanvas-body text-center">
          <ul class="navbar-nav align-items-center justify-content-start flex-grow-1 pe-3 gap-3 gap-md-0 mb-3 mb-md-0">
            <li class="nav-item">
              <router-link to="/" class="btn border-0 text-opacity-50 py-1 px-3 f-13 fw-600 text-white" :class="{'isActive':isPrimaryRoute}" @click="closeDropdown">Primary</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link to="/mandate-dashboard" class="btn border-0 py-1 px-3 f-13 fw-400 text-white text-opacity-50" :class="{'isActive':!isPrimaryRoute && $route.path === '/mandate-dashboard'}">Mandate</router-link>
            </li> -->
            
            <!-- <li class="nav-item">
              <router-link to="/syndicate-dashboard" class="btn border-0 py-1 px-3 f-13 fw-400 text-white text-opacity-50" :class="{'isActive':!isPrimaryRoute && $route.path === '/syndicate-dashboard'}">Syndicate</router-link>
            </li> -->
            
            <!-- <li class="nav-item">
              <a href="#" class="btn border-0 py-1 px-3 f-13 fw-400 text-white text-opacity-50">Loans</a>
            </li> -->
            <li class="nav-item">
              <router-link to="/settings" class="btn border-0 py-1 px-3 f-13 fw-400 text-white text-opacity-50" :class="{'isActive':!isPrimaryRoute && $route.path !== '/mandate-dashboard' && $route.path !== '/syndicate-dashboard'}" @click="closeDropdown">Settings</router-link>
            </li>
          </ul>
          <div class="dropdown d-inline-block ms-auto  text-center">
            <button class="btn border-0 py-1 px-0 f-13 fw-400 text-white text-opacity-50 d-inline-flex align-items-center gap-2 justify-content-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{userName}}
              <span class="d-block border bg-warning p-2 rounded-circle f-13 fw-600 text-dark text-opacity-75">{{userNameLetter}}</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-md-end py-0 bg-opacity-25">
              <li><a href="#" class="btn logout-btn w-100 f-13 fw-500" @click="logout">Logout</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
</template>
<script>
  export default {
    methods: {
      deleteLogoutCookies(){
        this.$cookies.remove('user-token');
        this.$cookies.remove('user-type');
        this.$cookies.remove('user-name');
        this.$cookies.remove('user-role');
        this.$cookies.remove('user-email');
      },
      logout(){
        this.$swal({
          title: "Are you sure?",
          icon: "warning",
          showCancelButton: true
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$axios.delete('central_report/logout')
              .then(res => {
                this.deleteLogoutCookies();
                this.$router.replace({name: 'Login'});
              })
              .catch(err => console.log(err));
          }
        });
      },
      closeDropdown() {
        if (window.innerWidth < 992) {
          this.$refs?.sideBar?.click();
        }
      }
    },
    computed: {
      userName(){
        return this.$cookies.get('user-name')
      },
      userNameLetter() {
        const name = this.$cookies.get('user-name') || '';
        return name?.slice(0,2).toUpperCase();
      },
      isPrimaryRoute(){
        return this.$route.path === '/performance-report' || this.$route.path === '/' || this.$route.path === '/leadsdashboard' || this.$route.path === '/demandfunnel';
      }
    },
  }
</script>
<style scoped>
.isActive{
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff !important;
}
.logout-btn:hover{
  background-color: #F0F6FB;
}

.dropdown-menu.dropdown-menu-md-end{
  margin-top: 12px;
}

</style>
